import { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import clsx from "clsx";
import { toast } from "react-toastify";
import { EmailModal } from "../EmailModal/EmailModal";

const PromoCycleModalForm = ({
  setOpenPromoCycleModal,
  setPromoCycleId,
  promoCycleId,
  getBookings,
}) => {

  const [promos, setPromos] = useState([])
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(1);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [displayType, setDisplayType] = useState('list')

  const cancel = () => {
    setOpenPromoCycleModal(false);
    setPromoCycleId(null);
    setOpenEmailModal(false);
  };

  const updatePage = (type) => {
    if (type === "dec" && page > 1 && page !== 1) {
      setPage(page - 1);
    } else if (type === "inc" && page >= 1) {
      if (page !== Math.ceil(total / pageSize)) {
        setPage(page + 1);
      }
    } else {
      setPage(type);
    }
  };



  const getPromoCycle = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/promo/cycles?cycle_id=${id}&page_size=${pageSize}&page=${page}`)
      .then(res => {
        setPromos(res.data.promo_codes);
        setTotal(res.data.total);
      })
      .catch(err => {
        toast.error(err?.response?.data?.message || "Error");
      });
  }

  useEffect(() => {
    getPromoCycle(promoCycleId)
  }, [page, pageSize]);



  return (
    <>
      <div className="kt_body">
        <div className="nav-group nav-group-fluid mb-3 d-inline-block">
          <label>
            <input
              type="radio"
              className="btn-check"
              name="cycle_type"
              checked={displayType === 'list'}
              onChange={() => {
                setDisplayType('list')
              }}
            />
            <span className="btn btn-sm btn-active btn-active-primary fs-6 fw-bold">
              List View
            </span>
          </label>
          <label>
            <input
              type="radio"
              className="btn-check"
              name="cycle_type"
              checked={displayType === 'grid'}
              onChange={() => {
                setDisplayType('grid')
              }}
            />
            <span className="btn btn-sm btn-active btn-active-primary px-4 fs-6 fw-bold">
              Grid View
            </span>
          </label>
        </div>
        <div style={{ maxHeight: '310px', overflowY: `${displayType === 'grid' ? 'auto' : 'hidden'}`, minHeight: 'auto', display: 'grid', gap: '10px', gridTemplateColumns: `${displayType === 'grid' ? 'repeat(2, 1fr)' : '1fr'}` }}>
          {
            promos && promos.length > 0 ?
              <>
                {displayType === 'list' ? <List promos={promos} getBookings={getBookings} /> : <Grid promos={promos} getBookings={getBookings} />}
              </>
              :
              <h4>No Promo Cycles Available</h4>
          }
        </div>
        <div className="row mt-10">
          <div className="col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start">
            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <select
                className="form-select form-select-solid fw-bolder"
                data-kt-select2="true"
                data-placeholder="Select Status"
                data-allow-clear="true"
                data-kt-user-table-filter="two-step"
                data-hide-search="true"
                onChange={(e) => setPageSize(e.target.value)}
                value={pageSize}
              >
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="200">200</option>
                <option value="500">500</option>
              </select>
            </div>
          </div>
          <div className="col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-lg-end">
            <div id="kt_table_users_paginate">
              {total > 0 && <ul className="pagination">
                {page > 1 && (
                  <li className={clsx("page-item", "previous")}>
                    <button
                      className={clsx("page-link", "next", "page-text")}
                      onClick={() => updatePage("dec")}
                      style={{ cursor: "pointer" }}
                      disabled={page === 1}
                    >
                      Previous Page
                    </button>
                  </li>
                )}
                <div style={{ display: "flex", gap: "5px", fontWeight: 700, fontSize: "14px" }}>
                  <span style={{ color: "#ffa459" }}>{page}</span>/ {Math.ceil(total / pageSize)}
                </div>
                <li className={clsx("page-item", "previous", page === Math.ceil(total / pageSize) && "disabled")}>
                  <button
                    className={clsx("page-link")}
                    onClick={() => updatePage("inc")}
                    style={{
                      cursor: page !== Math.ceil(total / pageSize) ? "pointer" : "default",
                      background: page !== Math.ceil(total / pageSize) ? "transparent" : "#e6e6e6",
                      color: page !== Math.ceil(total / pageSize) ? "#5e6278" : "#b2b2b2",
                      marginLeft: page === Math.ceil(total / pageSize) && "10px"
                    }}
                  >
                    Next Page
                  </button>
                </li>
                {Math.ceil(total / pageSize) > 5 && <div style={{ display: "flex", gap: "10px", alignItems: "center", marginLeft: '10px' }}>
                  <h6 style={{ marginBottom: '0' }}>Go To Page: </h6>
                  <select
                    style={{ width: "max-content" }}
                    className="form-select form-select-solid fw-bolder"
                    data-kt-select2="true"
                    data-placeholder="Select Status"
                    data-allow-clear="true"
                    data-kt-user-table-filter="two-step"
                    data-hide-search="true"
                    onChange={(e) => updatePage(+e.target.value)}
                    value={page}
                  >
                    {
                      [...Array(Math.ceil(total / pageSize))].map((_, i) => {
                        return (
                          <option value={i + 1}>{i + 1}</option>
                        )
                      }
                      )}
                  </select>
                </div>
                }
              </ul>
              }
            </div>
          </div>
        </div>
        <div className="d-flex gap-2 mt-5 justify-content-center">
          <button
            type="button"
            className="btn btn-sm btn-primary"
            onClick={() => cancel()}
          >
            Go Back
          </button>
          <button
            type="button"
            className="btn btn-sm bg-success text-white"
            onClick={() => setOpenEmailModal(true)}
          >
            Download Codes
          </button>
        </div>
      </div>
      {openEmailModal && <EmailModal cycleId={promoCycleId} onClose={() => setOpenEmailModal(false)} />}
    </>
  );
};

export { PromoCycleModalForm };

export const Grid = ({ promos, getBookings }) => {
  return promos.map((item, index) => {
    return (
      <div
        className="form-check form-check-custom form-check-solid"
        key={index}
        style={{
          background: moment(item.expiry_date).utc().isAfter(moment().utc()) && item.is_active ? "#e3feee9e" : "#f9f9f9",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
          borderRadius: "10px",
          flexWrap: "wrap"
        }}
      >
        <div className="fv-row w-50">
        <label className="fw-bold fs-6 mb-2">Code</label>
        <h5 className="fw-bolder text-main">{item.code}</h5>
        </div>
        <div className="fv-row w-50" style={{ textAlign: "right" }}>
          <label className="fw-bold fs-6 mb-2">Duration</label>
          <div>
            <h5 className="fw-bolder text-main">{(+item.discount_type === 3 && item?.is_ffa) && `${item.duration} ${item.duration === 1 ? +item.promo_type === 1 ? "Hour" : "Day" : +item.promo_type === 1 ? "Hours" : "Days"} Off`}</h5>
          </div>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Start Date</label>
          <h5 className="fw-bolder text-main">{moment(item.start_date).utc().format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50" style={{ textAlign: "right" }}>
          <label className="fw-bold fs-6 mb-2">Expiration Date</label>
          <h5 className="fw-bolder text-main">{moment(item.expiry_date).utc().format("YYYY-MM-DD")}</h5>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Total Usage</label>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}>
            <h5 className="fw-bolder text-main">{item.total_usage || "0"}</h5>
            {!!item.total_usage && (
              <button
                style={{
                  backgroundColor: "rgb(255, 164, 89)",
                  border: "none",
                  color: "white",
                  borderRadius: "2px"
                }}
                onClick={() => getBookings(item.code, item.total_usage || 1)}
              >
                Show
              </button>
            )}
          </div>
        </div>
        <div className="fv-row w-50" style={{ textAlign: "right" }}>
          <label className="fw-bold fs-6 mb-2">Total Usage Allowed</label>
          <div>
            <h5 className="fw-bolder text-main">{item.limit_overall || "-"}</h5>
          </div>
        </div>
        <div className="fv-row w-50">
          <label className="fw-bold fs-6 mb-2">Status</label>
          <h5 style={{
            color: item.is_active && moment(item.expiry_date).utc().isAfter(moment().utc()) ? "#2ecc71" : "#ed2626",
            fontWeight: 700
          }}>
            {item.is_active ? moment(item.expiry_date).utc().isAfter(moment().utc()) ? "Active" : "Expired" : 'Inactive'}
          </h5>
        </div>
      </div>
    )
  })
}

export const List = ({ promos, getBookings }) => {

  const headers = [
    { title: 'Promo Code', width: '180px' },
    { title: 'Duration', width: '120px' },
    { title: 'Start Date', width: '150px' },
    { title: 'Expiration Date', width: '150px' },
    { title: 'Status', width: '120px' },
    { title: 'Total Usage', width: '150px' },
    { title: 'Total Usage Allowed', width: '180px' },
  ]

  return (
    <div className='table-responsive' style={{ height: '320px' }}>
      <table
        id='kt_table_users'
        className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
      >
        <thead>
          <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
            {headers.map(column => (
              <th
                key={column.title}
                className={column.className}
                style={{ minWidth: column.width }}
              >
                {column.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className='text-gray-600 fw-bold'>
          {promos?.length > 0 && (
            promos.map(row => (
              <tr key={row.arrear_id}>
                <td style={{ minWidth: headers[0].width }}>{row.code}</td>
                <td style={{ minWidth: headers[1].width }}>{(+row.discount_type === 3 && row?.is_ffa) && `${row.duration} ${row.duration === 1 ? +row.promo_type === 1 ? "Hour" : "Day" : +row.promo_type === 1 ? "Hours" : "Days"} Off`}</td>
                <td style={{ minWidth: headers[2].width }}>{moment(row.start_date).utc().format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[3].width }}>{moment(row.expiry_date).utc().format("YYYY-MM-DD")}</td>
                <td style={{ minWidth: headers[4].width, color: row.is_active && moment(row.expiry_date).utc().isAfter(moment().utc()) ? '#2ecc71' : '#ed2626' }}>
                {row.is_active ? moment(row.expiry_date).utc().isAfter(moment().utc()) ? "Active" : "Expired" : 'Inactive'}
                </td>
                <td style={{ minWidth: headers[5].width }}>
                  {row.total_usage || "0"}
                  {!!row.total_usage && (
                    <button
                      className="btn btn-sm bg-main text-white rounded mx-2"
                      onClick={() => getBookings(row.code, row.total_usage || 1)}
                    >
                      Show
                    </button>
                  )}
                </td>
                <td style={{ minWidth: headers[6].width }}>{row.limit_overall || "-"}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  )
}